// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true*/
(function(){
  var define, is_node = typeof module=='object' && module.exports;
  if (is_node)
      define = require('../../../util/require_node.js').define(module, '..');
  else
      define = self.define;
define([], function(){
var E = {};
E.campaign_bonus = function(campaign){
    return ['static_res'].includes(campaign) ? campaign : null;
};
return E; }); })();
